var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 5 15 L 5 17 L 27 17 L 27 15 L 5 15 z","overflow":"visible"}));
}

Minus.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Minus;

Minus.default = Minus;
